import { DiagnosticReportCode } from '@quromedical/fhir-common';
import type { Field } from 'components/types';
import { patientFetcher } from 'integration';

interface DiagnosticReportParams {
  sort?: string;
  count?: number;
  pageToken?: string;
  id?: string;
  'based-on'?: string;
  status?: fhir4.DiagnosticReport['status'][];
  identifier?: string;
  subject?: string;
  date?: string;
  code?: string;
}

export const initialSearch: Partial<DiagnosticReportParams> = {
  code: DiagnosticReportCode.ampath,
};

export const searchFields: Field<DiagnosticReportParams>[] = [
  {
    subfields: [
      {
        type: 'combobox-single',
        searchable: true,
        key: 'subject',
        label: 'Patient',
        fetcher: patientFetcher,
      },
      {
        type: 'combobox-multiple',
        searchable: true,
        key: 'status',
        label: 'Status',
        fetcher: [
          {
            value: 'final',
            display: 'Final',
          },
          {
            value: 'preliminary',
            display: 'Preliminary',
          },
          {
            value: 'unknown',
            display: 'Unknown',
          },
        ],
      },
      {
        type: 'text-box',
        key: 'identifier',
        label: 'Order Number',
        placeholder: 'Order number of request',
      },
      {
        type: 'combobox-single',
        key: 'code',
        label: 'Provider',
        fetcher: [
          {
            value: DiagnosticReportCode.ampath,
            display: 'Ampath',
          },
        ],
      },
    ],
  },
];
